import api from './apiService';
import apiRoutes from './apiRoutes';

export const getAcademicYearsAsync = async () => {
  try {
    const response = await api.get(apiRoutes.getAcademicYears);
    return response.result;
  } catch (error) {
    throw error;
  }
};

export const getMyAnnualEvaluationAsync = async (academicYearId) => {
  try {
    const response = await api.get(apiRoutes.annualEvaluation.myScores(academicYearId));
    return response;
  } catch (error) {
    throw error;
  }
};
